import { Button, ButtonVariant, ButtonSize, Modal } from "shared/components";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

interface NoSubjectWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Hosts that stack above the page (the message pop-up) pass their modal layer. */
  zIndex?: number;
}

export const NoSubjectWarningModal = ({
  open,
  onClose,
  onConfirm,
  zIndex
}: NoSubjectWarningModalProps) => (
  <Modal
    opened={open}
    onClose={onClose}
    zIndex={zIndex}
    panelClassName="relative w-[366px] flex flex-col items-center p-6 gap-6 space-y-6"
  >
    <div className="rounded-full bg-warning-50 p-4">
      <HugeiconsIcon
        icon={Alert02Icon}
        size={32}
        className="text-warning-600"
      />
    </div>

    <p className="text-xl font-bold text-center">
      Do you want to send this message without a subject?
    </p>

    <div className="flex w-full gap-3 mt-2">
      <Button
        className="w-full"
        variant={ButtonVariant.BASE}
        size={ButtonSize.LG}
        onClick={onClose}
      >
        Don&apos;t send
      </Button>
      <Button
        className="w-full"
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.LG}
        onClick={onConfirm}
      >
        Send anyway
      </Button>
    </div>
  </Modal>
);
